import { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Tabs } from '../../components/Tabs';
import { Text } from '../../components/BaseComponents/styles';
import { FiscalCompanies } from './Companies';
import { FiscalEligibility } from './Eligibility';
import { FiscalServiceOrders } from './ServiceOrders';

const TABS = [
  { key: 'companies',      title: 'Empresas' },
  { key: 'eligibility',    title: 'Elegibilidade' },
  { key: 'service-orders', title: 'Ordens de Serviço' },
];

export const Fiscal = () => {
  const [setOptions] = useOutletContext();
  const [activeTab, setActiveTab] = useState('companies');

  useEffect(() => {
    setOptions({
      start: (
        <Text color="white" weight={700} style={{ textDecoration: 'underline' }}>
          Fiscal
        </Text>
      ),
    });
    return () => setOptions(null);
  }, []);

  return (
    <div>
      <Tabs activeTab={activeTab} onChange={setActiveTab} tabs={TABS} />
      {activeTab === 'companies'      && <FiscalCompanies />}
      {activeTab === 'eligibility'    && <FiscalEligibility />}
      {activeTab === 'service-orders' && <FiscalServiceOrders />}
    </div>
  );
};
